module.exports = __webpack_public_path__ + "media/large/real_estate_homes_rent-fc2b5bfb.jpeg";